import { defineStore } from 'pinia'
import { ref } from 'vue'
import { Constants } from 'src/helpers/constants'

/**
 * Holds ACLs properties and values
 */
export const useEnvironmentStore = defineStore('environmentStore', () => {
  const currentMod = ref(Constants.Modules.KDB)

  return {
    currentMod
  }
})
